<template>
  <tr v-if="loading">
    <td :colspan="colspan">
      <v-progress-linear
        :height="3"
        color="red"
        indeterminate
      ></v-progress-linear>
    </td>
  </tr>
</template>

<script>
import Mixin from "./Mixin"

export default {
  name: "TLoading",
  mixins: [Mixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
tr td {
  background: white;
}
</style>
